module.exports = __webpack_public_path__ + "img/02d.b5a1adcc.gif";